module.exports = __webpack_public_path__ + "mp.svg?d4c8612c389a887d815b3980f23370f1";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/mp.svg
// module id = 1324
// module chunks = 27